import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "home" }
const _hoisted_2 = {
  class: "title-container",
  ref: "titleContainer"
}
const _hoisted_3 = { class: "text" }
const _hoisted_4 = {
  class: "title",
  ref: "title"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h1", { class: "title title_before" }, "dewdle", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h1", { class: "title title_after" }, "dewdle", -1)
const _hoisted_7 = { class: "inputs" }
const _hoisted_8 = { class: "input" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Name", -1)
const _hoisted_10 = { class: "input" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { for: "id" }, "Game Id", -1)
const _hoisted_12 = { class: "buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", _hoisted_4, "dewdle", 512),
        _hoisted_5,
        _hoisted_6
      ])
    ], 512),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _withDirectives(_createElementVNode("input", {
          name: "name",
          class: "input-name",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.name) = $event)),
          type: "text",
          placeholder: "Enter your name"
        }, null, 512), [
          [_vModelText, _ctx.name]
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _withDirectives(_createElementVNode("input", {
          class: "input-id",
          name: "id",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.id) = $event)),
          type: "text",
          placeholder: "Enter a game id"
        }, null, 512), [
          [_vModelText, _ctx.id]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("button", {
        class: _normalizeClass([{ disabled: _ctx.name === '' }, "btn"]),
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.createGame && _ctx.createGame(...args)))
      }, " Create ", 2),
      _createElementVNode("button", {
        class: _normalizeClass([{ disabled: _ctx.name === '' }, "btn"]),
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.joinGame && _ctx.joinGame(...args)))
      }, _toDisplayString(_ctx.id ? "Join" : "Join random"), 3)
    ])
  ]))
}